// STARWEAVE — game HUD. A thin styled overlay (no per-frame DOM churn beyond
// the panel rows) over the WebGL canvas.

const el = (id: string) => document.getElementById(id);

export interface HudData {
  sub?: string;
  title?: string;
  rows?: [string, string][];
  bottom?: string;
}

let lastTitle = '';
let lastRowsKey = '';

export function bootDone(): void {
  const b = el('boot');
  if (b) b.style.display = 'none';
}

export function setHud(d: HudData): void {
  if (d.sub !== undefined) { const s = el('hudSub'); if (s) s.textContent = d.sub; }
  if (d.bottom !== undefined) { const b = el('hudBottom'); if (b) b.textContent = d.bottom; }
  if (d.rows) {
    // Only rebuild the panel structure when titles/keys change; otherwise just
    // update values, so we don't thrash the DOM every HUD tick.
    const key = (d.title || '') + '|' + d.rows.map((r) => r[0]).join(',');
    const panel = el('hudPanel');
    if (!panel) return;
    if (key !== lastRowsKey || d.title !== lastTitle) {
      panel.innerHTML =
        (d.title ? `<div class="title">${d.title}</div>` : '') +
        d.rows.map(([k]) => `<div class="row"><span class="k">${k}</span><span class="v"></span></div>`).join('');
      lastRowsKey = key;
      lastTitle = d.title || '';
    }
    const vals = panel.querySelectorAll('.row .v');
    d.rows.forEach(([, v], i) => { if (vals[i]) vals[i].textContent = v; });
  }
}
